"use strict";
/* eslint-disable no-underscore-dangle */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenService = exports.MessageBusService = exports.addService = exports.getServices = exports.getService = void 0;
var getService = function (name) { var _a; return (_a = window === null || window === void 0 ? void 0 : window.__mf) === null || _a === void 0 ? void 0 : _a.services[name]; };
exports.getService = getService;
var getServices = function () { var _a; return (_a = window === null || window === void 0 ? void 0 : window.__mf) === null || _a === void 0 ? void 0 : _a.services; };
exports.getServices = getServices;
var addService = function (name, instance, options) {
    var _a;
    var _b;
    var existingService = (0, exports.getService)(name);
    if (existingService && !(options === null || options === void 0 ? void 0 : options.allowOverwrite))
        return existingService;
    if (window) {
        window.__mf = __assign(__assign({}, window.__mf), { services: __assign(__assign({}, (_b = window.__mf) === null || _b === void 0 ? void 0 : _b.services), (_a = {}, _a[name] = instance, _a)) });
    }
    return instance;
};
exports.addService = addService;
exports.MessageBusService = typeof window !== 'undefined' && ((_a = window.__mf) === null || _a === void 0 ? void 0 : _a.services.MessageBusService);
exports.TokenService = typeof window !== 'undefined' && ((_b = window.__mf) === null || _b === void 0 ? void 0 : _b.services.TokenService);
